import React, { useState } from 'react'

import { Button, Heading } from '@/components'

import OralExamResults from './OralExamResults'

import './OralExam.scss'

const OralExamComplete = ({
  isPractice = false,
  onClickBack,
  passed,
  results,
  score = 0,
}) => {
  const [view, setView] = useState('main')

  if (view === 'results') {
    return (
      <OralExamResults
        isPractice={isPractice}
        onClickBack={() => setView('main')}
        results={results}
      />
    )
  }

  return (
    <div className="oral-exam__complete-wrapper">
      <div className="oral-exam__wrapper">
        <div className="oral-exam__completion">
          <Heading is2>
            {passed ? 'Practice passed' : 'Practice failed'}
          </Heading>
          <div className="oral-exam__score-display">
            <span className="oral-exam__score-label">Your Score</span>
            <div className="oral-exam__score-circle">
              {passed ? (
                <div className="oral-exam__score-checkmark">&#10003;</div>
              ) : (
                <div className="oral-exam__score-x">&#10005;</div>
              )}
            </div>
            <span className="oral-exam__score-text">
              {`${Math.floor(score)}%`}
            </span>
          </div>

          <p className="oral-exam__completion-message">
            {passed
              ? "Congratulations, you've passed this Oral Exam. You can view your results for this Exam and past attempts at any time from the Exam Home Page by selecting Review under Oral Exam."
              : 'You did not pass this Oral Exam. You can view your results for this Exam and past attempts at any time from the Exam Home Page by selecting Review under Oral Exam.'}
          </p>
        </div>

        <div className="oral-exam__done-buttons">
          {results && results.length > 0 && (
            <Button isSuccess isRounded onClick={() => setView('results')}>
              View Results
            </Button>
          )}
          {onClickBack && (
            <Button isInfo isRounded onClick={onClickBack}>
              Back to Exam Home
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default OralExamComplete
